// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P2P User Payment Methods */
.p2p-payment-methods-page .dashboard-body {
  padding-bottom: 2rem;
}

.p2p-payment-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.35);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.p2p-payment-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.p2p-payment-stat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.p2p-payment-stat-card__icon {
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
}

.p2p-payment-stat-card__icon--default {
  color: #64748b;
}

.p2p-payment-stat-card__icon--active {
  color: #16a34a;
}

.p2p-payment-stat-card__icon--inactive {
  color: #dc2626;
}

.p2p-payment-stat-card__value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.p2p-payment-stat-card__label {
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

.p2p-payment-filters-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.p2p-payment-filters__title {
  margin: 0 0 1rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.p2p-payment-filters__title i {
  color: #0f766e;
}

.p2p-payment-filters-row {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
}

.p2p-payment-filter-group {
  min-width: 160px;
}

.p2p-payment-filter-group label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-muted, #64748b);
}

.p2p-payment-filter-group input,
.p2p-payment-filter-group select {
  width: 100%;
  padding: 0.6rem 0.85rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  color: var(--text, #1e293b);
}

.p2p-payment-btn-reset {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text, #475569);
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.p2p-payment-btn-reset:hover {
  background: #e2e8f0;
}

.p2p-payment-list-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.p2p-payment-list__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.p2p-payment-list__title i {
  color: #0f766e;
}

.p2p-payment-table-wrap {
  overflow-x: auto;
}

.p2p-payment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.p2p-payment-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.p2p-payment-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
}

.p2p-payment-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.p2p-payment-table tbody tr:hover {
  background: #f8fafc !important;
}

.p2p-payment-user {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.p2p-payment-user__name {
  font-weight: 600;
}

.p2p-payment-user__email {
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.p2p-payment-status-badge {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.p2p-payment-status-badge--active {
  background: #dcfce7;
  color: #166534;
}

.p2p-payment-status-badge--inactive {
  background: #f1f5f9;
  color: #64748b;
}

.p2p-payment-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.p2p-payment-action-btn {
  padding: 0.35rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.p2p-payment-action-btn:hover {
  opacity: 0.9;
}

.p2p-payment-action-btn--view {
  background: #0f766e;
  color: #fff;
}

.p2p-payment-action-btn--edit {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.p2p-payment-action-btn--deactivate {
  background: #ea580c;
  color: #fff;
}

.p2p-payment-action-btn--activate {
  background: #16a34a;
  color: #fff;
}

.p2p-payment-action-btn--delete {
  background: #dc2626;
  color: #fff;
}

/* Modal */
.p2p-payment-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.p2p-payment-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.p2p-payment-modal__title {
  margin: 0 0 1.25rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.p2p-payment-modal__group {
  margin-bottom: 1rem;
}

.p2p-payment-modal__group label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text, #1e293b);
}

.p2p-payment-modal__group input,
.p2p-payment-modal__group select {
  width: 100%;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
}

.p2p-payment-modal__actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
  justify-content: flex-end;
}

.p2p-payment-modal-btn {
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.p2p-payment-modal-btn--cancel {
  background: #f1f5f9;
  color: #475569;
}

.p2p-payment-modal-btn--submit {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.p2p-payment-view-body {
  margin-bottom: 1rem;
}

.p2p-payment-view-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.9rem;
}

.p2p-payment-view-label {
  color: var(--text-muted, #64748b);
  margin-right: 1rem;
}

@media (max-width: 768px) {
  .p2p-payment-stats {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/P2P/P2PUserPaymentMethodsPage.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* P2P User Payment Methods */\n.p2p-payment-methods-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.p2p-payment-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.35);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.p2p-payment-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.p2p-payment-stat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.p2p-payment-stat-card__icon {\n  font-size: 1.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.p2p-payment-stat-card__icon--default {\n  color: #64748b;\n}\n\n.p2p-payment-stat-card__icon--active {\n  color: #16a34a;\n}\n\n.p2p-payment-stat-card__icon--inactive {\n  color: #dc2626;\n}\n\n.p2p-payment-stat-card__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.p2p-payment-stat-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n.p2p-payment-filters-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.p2p-payment-filters__title {\n  margin: 0 0 1rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.p2p-payment-filters__title i {\n  color: #0f766e;\n}\n\n.p2p-payment-filters-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.p2p-payment-filter-group {\n  min-width: 160px;\n}\n\n.p2p-payment-filter-group label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-muted, #64748b);\n}\n\n.p2p-payment-filter-group input,\n.p2p-payment-filter-group select {\n  width: 100%;\n  padding: 0.6rem 0.85rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text, #1e293b);\n}\n\n.p2p-payment-btn-reset {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text, #475569);\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.p2p-payment-btn-reset:hover {\n  background: #e2e8f0;\n}\n\n.p2p-payment-list-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.p2p-payment-list__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.p2p-payment-list__title i {\n  color: #0f766e;\n}\n\n.p2p-payment-table-wrap {\n  overflow-x: auto;\n}\n\n.p2p-payment-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.p2p-payment-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.p2p-payment-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.p2p-payment-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.p2p-payment-table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.p2p-payment-user {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.p2p-payment-user__name {\n  font-weight: 600;\n}\n\n.p2p-payment-user__email {\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n}\n\n.p2p-payment-status-badge {\n  display: inline-block;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.p2p-payment-status-badge--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.p2p-payment-status-badge--inactive {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.p2p-payment-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.p2p-payment-action-btn {\n  padding: 0.35rem 0.7rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.p2p-payment-action-btn:hover {\n  opacity: 0.9;\n}\n\n.p2p-payment-action-btn--view {\n  background: #0f766e;\n  color: #fff;\n}\n\n.p2p-payment-action-btn--edit {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.p2p-payment-action-btn--deactivate {\n  background: #ea580c;\n  color: #fff;\n}\n\n.p2p-payment-action-btn--activate {\n  background: #16a34a;\n  color: #fff;\n}\n\n.p2p-payment-action-btn--delete {\n  background: #dc2626;\n  color: #fff;\n}\n\n/* Modal */\n.p2p-payment-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.p2p-payment-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.p2p-payment-modal__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.p2p-payment-modal__group {\n  margin-bottom: 1rem;\n}\n\n.p2p-payment-modal__group label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text, #1e293b);\n}\n\n.p2p-payment-modal__group input,\n.p2p-payment-modal__group select {\n  width: 100%;\n  padding: 0.7rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 8px;\n}\n\n.p2p-payment-modal__actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1.5rem;\n  justify-content: flex-end;\n}\n\n.p2p-payment-modal-btn {\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.p2p-payment-modal-btn--cancel {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.p2p-payment-modal-btn--submit {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.p2p-payment-view-body {\n  margin-bottom: 1rem;\n}\n\n.p2p-payment-view-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.9rem;\n}\n\n.p2p-payment-view-label {\n  color: var(--text-muted, #64748b);\n  margin-right: 1rem;\n}\n\n@media (max-width: 768px) {\n  .p2p-payment-stats {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
